import React from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import huHU from 'date-fns/locale/hu';
import DatePickerCustomInput from './DatePickerCustomInput';
import './datepicker.css';
import DateUtils from '@utils/DateUtils';

registerLocale('hu-HU', huHU);


interface PropType {
    name: string;
    value: string | null | undefined;
    placeholder?: string;
    hint?: string;
    isClearable?: boolean;
    required?: boolean;
    onChange: (value: any, name: string) => void;
}

const InputDateTime = (props: PropType) => {
    const { name, value, onChange, placeholder, ...otherProps} = props;
    return (
        <>
            <DatePicker
                customInput={<DatePickerCustomInput />}
                selected={value ? new Date(value) : null}
                onChange={(date: Date) => {
                    onChange((date ? DateUtils.formatDateTime(date) : ''), name);
                }}
                onSelect={(date: Date) => {
                    onChange((date ? DateUtils.formatDateTime(date) : ''), name);
                }}
                dateFormat={'yyyy-MM-dd HH:mm:ss'}
                timeFormat={'HH:mm'}
                timeIntervals={30}
                showTimeSelect={true}
                locale={'hu-HU'}
                isClearable={props.isClearable !== undefined ? props.isClearable : (props.required ? false : true)}
                placeholderText={placeholder}
                {...otherProps}
            />
            {props.hint && <span className="form-text m-b-none">{props.hint}</span>}
        </>
    );
};

export default InputDateTime;



// WEBPACK FOOTER //
// ./src/components/Form/InputDateTime.tsx